import AgentManagement from "./agents/AgentManagement";
import AgentPerformance from "./agents/AgentPerformance";
import CustomerSurveys from "./CustomerSurveys";
import CustomerTickets from "./CustomerTickets";

const customerObsessionRoutes = [
    {
        path: "/core/agents",
        element: <AgentManagement />,
    },
    {
        path: "/core/agent-performance",
        element: <AgentPerformance />,
    },
    {
        path: "/core/customer-tickets",
        element: <CustomerTickets />,
    },
    {
        path: "/core/customer-surveys",
        element: <CustomerSurveys />,
    }
];

export default customerObsessionRoutes;